import { Banner,Category,Products } from "../components";
const Main: React.FC = () => {
  return (
    <>
      <Banner />
      <Category />
      <Products />
    </>
  );
};

export default Main;
